// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js??ref--6-2!./vue-phone-number-input.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("f64676b8", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/vue-phone-number-input/dist/vue-phone-number-input.css
// module id = 851
// module chunks = 0